// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const ErrorDeclarationDiscriminantValue = {
    property: (value) => {
        return Object.assign(Object.assign({}, value), { type: "property", _visit: function (visitor) {
                return FernIr.ErrorDeclarationDiscriminantValue._visit(this, visitor);
            } });
    },
    statusCode: () => {
        return {
            type: "statusCode",
            _visit: function (visitor) {
                return FernIr.ErrorDeclarationDiscriminantValue._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "property":
                return visitor.property(value);
            case "statusCode":
                return visitor.statusCode();
            default:
                return visitor._other(value);
        }
    },
};
